export enum LureComplexity {
  easy = "easy",
  medium = "medium",
  difficult = "difficult",
}

export type LureSchedule = {
  user_uuid: string;
  user_name: string;
  topic?: string;
  subject: string;
  sender_name: string;
  from: string;
  complexity?: keyof typeof LureComplexity;
  body: string;
};

export const SLIDE_IN = "SLIDE_IN";
export const SLIDE_OUT = "SLIDE_OUT";

export type SlideOutState = typeof SLIDE_IN | typeof SLIDE_OUT;
